import {
  createContext,
  ReactNode,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
  useMemo,
} from 'react'
import { Payment } from '~/shared/api/services/orders/types'

export interface CheckoutContextType {
  isNeedPay: boolean
  setIsNeedPay: Dispatch<SetStateAction<boolean>>
  isRecipient: boolean
  isPersonalDataActive: boolean
  paymentMethods: Payment[]
  isNext: boolean
  setIsNext: Dispatch<SetStateAction<boolean>>
  setPaymentMethods: Dispatch<SetStateAction<Payment[]>>
  setIsRecipient: Dispatch<SetStateAction<boolean>>
  setIsPersonalDataActive: Dispatch<SetStateAction<boolean>>
}

export const CheckoutContext = createContext<CheckoutContextType | undefined>(
  undefined,
)

export const CheckoutProvider = ({ children }: { children: ReactNode }) => {
  const [isNeedPay, setIsNeedPay] = useState(false)
  const [isRecipient, setIsRecipient] = useState(true)
  const [isPersonalDataActive, setIsPersonalDataActive] = useState(true)
  const [isNext, setIsNext] = useState(false)
  const [paymentMethods, setPaymentMethods] = useState<Payment[]>([])

  const value = useMemo<CheckoutContextType>(
    () => ({
      isNeedPay,
      setIsNeedPay,
      isRecipient,
      paymentMethods,
      isNext,
      setIsNext,
      setPaymentMethods,
      setIsRecipient,
      isPersonalDataActive,
      setIsPersonalDataActive,
    }),
    [isNeedPay, isRecipient, paymentMethods, isNext, isPersonalDataActive],
  )

  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  )
}

export const useCheckout = () => {
  const context = useContext(CheckoutContext)

  if (context === undefined) {
    throw new Error('useCheckout must be used within a CheckoutProvider')
  }

  return context
}
